<template>
  <!-- <wp-user-management-component /> -->
  <carts-management-component />
</template>


<script>
import CartsManagementComponent from "@/spa/components/board/carts-management/BoardCartsManagement";
export default {
  name: "CartsManagementPage",
  components: {
    CartsManagementComponent
  }
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/operation/CartsManagementPage .vue